// src/sections/MainDishes/MainDishes.js
import React from 'react';
import styles from './MainDishes.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHeart as solidHeart } from '@fortawesome/free-solid-svg-icons';
import { faHeart as regularHeart } from '@fortawesome/free-regular-svg-icons';

// CORRIGÉ : Ordre et contenu des plats mis à jour pour correspondre au menu
const mainDishesData = [
  {
    id: "dish-bobun",
    name: "SALADE BO BUN (BOEUF ET NEMS)",
    price: "10.00€",
    description: "Ingrédients : Vermicelle de riz, salade, soja frais, concombre, carotte, boeuf, nems poulet, cacahuètes, menthe, coriandre."
  },
  {
    id: "dish-pho",
    name: "SOUPE PHO",
    price: "10.00€",
    description: "Ingrédients : Nouille de riz, soja frais, oignons rouges, boeuf, herbes aromatiques, bouillon de boeuf."
  },
  {
    id: "dish-loklak",
    name: "BOEUF LOK LAK (BOEUF SAUTÉ AUX OIGNONS)",
    price: "11.00€",
    description: "" // Description retirée car absente du menu
  },
  {
    id: "dish-lombok",
    name: "LOMBOK (POULET OU BOEUF)",
    price: "11.00€",
    description: "Ingrédients : Riz frit, choux blanc, carotte, ail, cacahuètes, sauce indonésienne."
  },
  {
    id: "dish-padthai",
    name: "PAD THAI POULET",
    price: "11.50€",
    description: "Ingrédients : Nouille de riz, soja frais, choux blanc, cacahuètes."
  }
];

const MainDishes = ({ id, favorites, addFavorite, removeFavorite }) => {
  
  const isFavorite = (item) => {
    return favorites.some(favItem => favItem.id === item.id);
  };

  const handleFavoriteClick = (item) => {
    if (isFavorite(item)) {
      removeFavorite(item.id);
    } else {
      addFavorite(item);
    }
  };

  return (
    <section id={id} className={styles.mainDishes}>
      <div className={styles.container}>
        <h2 className={styles.sectionTitle}>NOS PLATS</h2>
        <div className={styles.menuList}>
          {mainDishesData.map((item) => (
            <div key={item.id} className={styles.menuItem}>
              <div className={styles.itemHeader}>
                <span className={styles.itemName}>{item.name}</span>
                <span className={styles.itemSeparator}></span>
                
                <div className={styles.priceAndFavorite}>
                  <span className={styles.itemPrice}>{item.price}</span>
                  <button
                    className={`${styles.favoriteButton} ${isFavorite(item) ? styles.isFavorite : ''}`}
                    onClick={() => handleFavoriteClick(item)}
                    aria-label={isFavorite(item) ? `Retirer ${item.name} des favoris` : `Ajouter ${item.name} aux favoris`}
                  >
                    <FontAwesomeIcon icon={isFavorite(item) ? solidHeart : regularHeart} />
                  </button>
                </div>

              </div>
              {item.description && (
                <p className={styles.itemDescription}>{item.description}</p>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default MainDishes;